<script setup lang="ts">
import type { EsProduct } from '~/nuxt3-base/app/types/elastic'
import TwSuggestionsQuery from '~layers/app/graphql/pdp/twSuggestions.gql'

const props = defineProps<{ product: EsProduct, groupKey?: string, single?: boolean }>()
const sliders = ref<any[]>([])

const { profileKey } = useTweakwise()

const limitedSliders = computed(() => {
  if (props.single) {
    return sliders.value.slice(0, 1)
  }
  return sliders.value
})

onMounted(() => {
  const { onResult } = useQuery(TwSuggestionsQuery, () => ({
    twItemId: props.product.tweakwiseId,
    profileKey: profileKey.value,
    groupKey: props.groupKey || '',
  }))

  onResult((queryResult) => {
    if (queryResult.data?.twRecommendations?.recommendations) {
      sliders.value = queryResult.data?.twRecommendations?.recommendations
    }
  })
})
</script>

<template>
  <div
    v-for="slider in limitedSliders"
    :key="slider.name"
  >
    <section>
      <ProductSlider :products="slider.items">
        <div :class="`heading heading--3`">
          &nbsp;
        </div>
      </ProductSlider>
    </section>
  </div>
</template>
